import { getColor } from '@karma/components/colors';
import styled, { css } from 'styled-components';

export const InfoPageListItem = styled.li`
  counter-increment: item;
  position: relative;
  text-align: justify;

  &:before {
    content: counters(item, '.') '. ';
  }

  @media (max-width: 440px) {
    font-size: 16px;
  }

  ${({ linksTitle }) =>
    linksTitle &&
    css`
      &:before {
        margin-right: 10px;
        left: -30px;
        position: absolute;
        display: inline-block;
        font-weight: 600;
        line-height: 1.5;
        color: ${getColor('primary1')};
      }
    `}

  ${({ level_1 }) =>
    level_1 &&
    css`
      padding: 20px 0 20px 0;
      &:before {
        position: absolute;
        left: -25px;
        font-weight: 600;
        line-height: 1.5;
        color: ${getColor('primary1')};
      }
      &:nth-child(n + 10) {
        &:before {
          left: -30px;
        }
      }
    `}

    ${({ level_2 }) =>
    level_2 &&
    css`
      padding: 20px 0 20px 0;
      font-size: 18px;

      &:before {
        position: absolute;
        left: -60px;
        width: 60px;
        text-align: right;
        font-weight: 600;
        line-height: 1.5;
        color: ${getColor('primary1')};
      }
    `}
     
    ${({ level_3 }) =>
    level_3 &&
    css`
      padding: 10px 0 10px 0;
      font-size: 18px;

      &:before {
        position: absolute;
        left: -60px;
        width: 60px;
        text-align: right;
        font-weight: 600;
        line-height: 1.5;
        color: ${getColor('primary1')};
      }

      &:last-child {
        padding: 10px 0 0px 0;
      }
    `}

    ${({ level_4 }) =>
    level_4 &&
    css`
      padding: 10px 0 10px 0;
      font-size: 18px;

      &:before {
        position: absolute;
        left: -80px;
        width: 80px;
        text-align: right;
        font-weight: 600;
        line-height: 1.5;
        color: ${getColor('primary1')};
      }

      &:last-child {
        padding: 10px 0 0px 0;
      }
    `}

    ${({ subtitle }) =>
    subtitle &&
    css`
        font-weight: 600;
        font-size: 20px;
        color: ${getColor('primary1')};
        }
      `}
`;
